export const GROUP_KIND = {
  CHAT: 'chat',
  EXEC: 'exec',
  EXTRACT: 'extract',
  ROW: 'row',
};
